import { BreakPoint } from '@makemydeal/dr-activities-common';
import styled from 'styled-components';

export const ContextualCommentsContainer = styled.div<{ $visible: boolean }>`
    &.deal-comments-drawer {
        width: 100%;
        position: static;
        z-index: 0;
    }
    &.deal-comments-baseFooter {
        width: 407px;
        right: 360px;
        position: absolute;
        bottom: 60px;
    }

    &.deal-comments-footer {
        width: 407px;
        right: 235px;
        position: absolute;
        bottom: 60px;
    }

    z-index: 1002;
    /* useClickOutside (see ../common/useClickOutside.ts) bails out via getClientRects()[0] being
       empty when this element is display:none — without this, a display:block-but-zero-height
       box (its only child, PanelContentContainer, is display:none while closed) still yields a
       real, zero-height rect, so almost every click on the page reads as "outside" and closes it. */
    display: ${({ $visible }) => ($visible ? 'block' : 'none')};

    @media (max-width: ${BreakPoint.SCREEN_MD_MIN}) {
        width: 100% !important;
        right: 0 !important;
    }
`;
